
        import 'TextInput.bdf9b4f.css-module'
        export default {"Label":"Label_TextInput_bdf9b4f","placeholder":"placeholder_TextInput_bdf9b4f","TextAreaLabel":"TextAreaLabel_TextInput_bdf9b4f"}
    